import BaseViz from './BaseViz'
import ChoroplethChart from '../charts/ChoroplethChart'
import ChoroplethDataController from '../viz_behaviors/ChoroplethDataController'
import { select as d3_select } from 'd3-selection'
import { encodeDate } from '@/utils/dates.js'

export default class ChoroplethViz extends BaseViz {
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: true,
      },
    },
    TooltipBehavior: {
      onCentroid: {
        value: true,
      },
      getHtml: function(d) {
        return `<div class="columns">
          <div class="column"><p class="important">
            ${d.label}
          </p><p>
            ${encodeDate(d.year)}
          </p></div>
          <div class="column"><p class="value">
            ${this.valueWithUnit(d.value, 'y')}
          </p></div>
        </div>`
      },
      getItemOffset: function(el) {
        let rect, polygon
        if (this.config.TooltipBehavior.onCentroid) {
          if (!el.boundingPath) {
            let _bbox, _area
            polygon = el
              .getElementsByTagName('path')[0]
              .getAttribute('d')
              .split('M')
              .reduce(
                (acum, poly) => {
                  _bbox = poly.split('L').reduce(
                    (bbox, seg) => {
                      seg
                        .split(',')
                        .map(parseFloat)
                        .map((d, i) => {
                          if (isNaN(d)) return bbox
                          if (i) {
                            bbox.top = Math.min(d, bbox.top)
                            bbox.bottom = Math.max(d, bbox.bottom)
                          } else {
                            bbox.left = Math.min(d, bbox.left)
                            bbox.right = Math.max(d, bbox.right)
                          }
                        })
                      return bbox
                    },
                    {
                      left: Infinity,
                      right: -Infinity,
                      top: Infinity,
                      bottom: -Infinity,
                    }
                  )
                  _area = (_bbox.right - _bbox.left) * (_bbox.bottom - _bbox.top)
                  if (acum.area < _area && isFinite(_area)) {
                    acum.path = 'M' + poly
                    acum.area = _area
                  }
                  return acum
                },
                {
                  area: null,
                  path: null,
                }
              )
            el.boundingPath = polygon.path
          }
          let ref = document.createElementNS('http://www.w3.org/2000/svg', 'path')
          ref.setAttribute('fill', '#ff0000')
          this.$root.appendChild(ref)
          let sel = d3_select(el)
          let tr = sel.select('path').attr('transform')
          ref.setAttribute('d', el.boundingPath)
          if (tr) ref.setAttribute('transform', tr)
          rect = ref.getBoundingClientRect()
          this.$root.removeChild(ref)
          // rect = el.boundingRect
        } else {
          rect = el.getBoundingClientRect()
        }

        var pos = {
          x: rect.x + rect.width / 2,
          y: rect.y + rect.height / 2 - 5,
        }

        return pos
      },
      hasTooltip: function(d) {
        return d.value !== undefined
      },
    },
  }
  static chartClass = ChoroplethChart
  static dataControllerClass = ChoroplethDataController
}
